import MiotStat from '@mi/spmjs/lib/spm.rn.web';
import BSLUtils from 'bsl/utils/utils.js';
import ld from 'lodash';
import { getTraceData } from '@mi/rn-trace';
import AuthUtil from 'common/AuthUtil';
import { encodeMid } from '@mi/mid-tools';
import Monitor from 'base/utils/monitor/index';

const ypm = new MiotStat({ spmA: 'MiShop_M', mode: 'shop' });
export { ypm };
let tempSpmref = '';
let tempTime = 0;
const dealWithIid = (iid, extraConstants) => {
  const extra = Object.keys(extraConstants)
    .map((key) => `${key}=${encodeURIComponent(extraConstants[key])}`)
    .join('&');
  return encodeURIComponent(iid ? `${iid}${extra ? `&${extra}` : ''}` : extra);
};

const preDeal = (func) => {
  const f = async (...args) => {
    AuthUtil.getUserInfo().then((data) => {
      AuthUtil.xiaomi_id = (data || {}).user_id;
      func(...args);
    });
  };
  return f;
};
class YPStatSend {
  constructor(uriKVs = {}, pageName = '', extra = {}) {
    const { extraConstants = {}, uri = '' } = extra;
    this.currentUri = uri;
    this.scm = uriKVs.scm || '';
    this.scmv2 = uriKVs.scmv2 || '';
    this.last_scmv2 =
      uriKVs.last_scmv2 ||
      uriKVs.scmref ||
      ld.get(uriKVs, 'action.spm_stat.scm') ||
      ld.get(uriKVs, 'action.spm_stat.scmref') ||
      '';
    this.scmv2_num = uriKVs.scmv2_num || uriKVs.scm_step || ld.get(uriKVs, 'action.spm_stat.scm_step') || 0;
    this.pageName = pageName;
    this.extraConstants = extraConstants;
  }

  setSpmB(b) {
    this.pageName = b;
  }

  getParam(param = {}, area, eventType) {
    const reParam = Object.assign(param, { last_scmv2: this.last_scmv2, scmv2_num: this.scmv2_num });
    const { pageName = this.pageName, spm, scmv2 = '' } = reParam;
    if (!scmv2.length > 0) {
      // 当前坑位存在scmv2 重置last_scmv2 & scmv2_num
      delete reParam.scmv2;
    }
    reParam.scm = reParam.scm || reParam.scmv2;
    reParam.pageName = reParam.pageName || this.pageName;
    reParam.uri = this.currentUri;
    if ((spm && typeof spm === 'object') || spm === undefined) {
      // 优先取spm中的b和c位， 其次取area和pageName
      reParam.spm = ypm.getSpm(
        {
          b: pageName,
          c: area,
          d: 1,
          ...spm,
        },
        eventType,
      );
    }
    reParam.xiaomi_id = AuthUtil.xiaomi_id ? encodeMid(AuthUtil.xiaomi_id) : '';
    return reParam;
  }

  visible = preDeal((area, iid = '', param = {}) => {
    const reParam = this.getParam(param, area);
    ypm.visible(area, dealWithIid(iid, this.extraConstants), { ...reParam });
    Monitor?.recordVisibleEvent?.({
      name: reParam.spm,
      info: {
        spm: reParam.spm,
        iid,
      },
    });
  });

  touch = preDeal((area, iid = '', param = {}) => {
    console.log('click here', area, iid, param);
    const reParam = this.getParam(param, area, 'touch');
    const spmSplit = reParam.spm?.split?.('.') || [];
    const testID = `${spmSplit[2]}.${spmSplit[3]}`;
    Monitor?.recordTouchEvent?.({
      name: testID,
      info: {
        tag: testID,
        spm: reParam.spm,
        iid,
      },
    });
    if (reParam.spm && typeof reParam.spm === 'string') {
      tempSpmref = reParam.spm;
      tempTime = Date.now();
    }
    ypm.touch(area, dealWithIid(iid, this.extraConstants), { ...reParam });
    console.log('=====touch', area, iid, reParam.spm, testID);
    if (reParam.pageName === 'giftcard_list') {
    }
  });

  view = preDeal((pageName, url, param = {}) => {
    const reParam = this.getParam({
      ...param,
      pageName,
    });
    ypm.view(pageName, url, undefined, dealWithIid('', this.extraConstants), reParam);
  });

  viewend = preDeal((pageName, url, param = {}) => {
    const reParam = this.getParam({
      ...param,
      uri: url,
    });
    ypm.viewend('', reParam);
  });

  info = preDeal((area, iid = '', param = {}) => {
    const reParam = this.getParam(param, area);
    ypm.info(area, dealWithIid(iid, this.extraConstants), { ...reParam });
  });

  custom = preDeal((eventName, area, iid, params = {}) => {
    const reParam = this.getParam(params, area);
    ypm.custom(eventName, area, dealWithIid(iid, this.extraConstants), reParam);
  });

  getSpm = (param) => {
    try {
      return ypm.getSpm(param);
    } catch (error) {
      console.log('Get spm Error:', error);
      return param.url || '';
    }
  };

  getSpmAndScm = (param) => {
    let _url = '';
    if (typeof param === 'object') {
      _url = ypm.getSpm({
        ...param,
      });
    } else {
      _url = param;
    }
    let scmv2 = this.last_scmv2 || '';
    let scmV2Num = this.scmv2_num || 0;
    if (param.scmv2) {
      scmv2 = scmv2 ? scmv2 + ',' + param.scmv2 : param.scmv2;
      scmV2Num = 0;
    } else {
      scmV2Num++;
    }
    if (scmv2) {
      _url = BSLUtils.addParams(_url, [
        {
          key: 'last_scmv2',
          value: scmv2,
        },
        {
          key: 'scmv2_num',
          value: scmV2Num,
        },
      ]);
    }

    return _url;
  };

  getLastScmV2 = () => {
    return this.last_scmv2;
  };

  getLastScmV2Step = () => {
    return this.scmv2_num;
  };

  // 直接进行数据的上报，兼容组件库的使用
  traceVisible = (traceId = '', traceData = {}, scmv2, pageName) => {
    const { operation, b, c, d, iid } = getTraceData(pageName || this.pageName, traceId, {
      traceData,
      type: 'visible',
    });

    if (operation?.includes('visible')) {
      const { spm } = this.getParam({ spm: { b, c, d } }, undefined, undefined);
      this.visible(c, iid, { spm, scmv2 });
    }
  };

  traceTouch = (traceId = '', traceData = {}, scmv2, pageName) => {
    const { operation, b, c, d, iid } = getTraceData(pageName || this.pageName, traceId, { traceData, type: 'touch' });

    const { spm } = this.getParam({ spm: { b, c, d } }, undefined, 'touch');
    if (operation?.includes('touch')) {
      this.touch(c, iid, { spm, scmv2 });
    }
    return spm;
  };
}

const getSpmrefInfo = () => {
  return {
    tempSpmref,
    tempTime,
  };
};

export { getSpmrefInfo };
export default YPStatSend;
